"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFitText = _interopRequireDefault(require("@plutonium-js/react-fit-text"));

var _toPx = _interopRequireDefault(require("to-px"));

var _Fonts = require("../00_environment/Fonts");

var _Container = _interopRequireDefault(require("./Container"));

var _Colors = require("../00_environment/Colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TitledContainer = function TitledContainer(_ref) {
  var title = _ref.title,
      rightButtonText = _ref.rightButtonText,
      _ref$onRightButtonCli = _ref.onRightButtonClick,
      onRightButtonClick = _ref$onRightButtonCli === void 0 ? function () {} : _ref$onRightButtonCli,
      children = _ref.children,
      backgroundColor = _ref.backgroundColor,
      fontSize = _ref.fontSize,
      _ref$noSidePadding = _ref.noSidePadding,
      noSidePadding = _ref$noSidePadding === void 0 ? false : _ref$noSidePadding,
      _ref$fullHeight = _ref.fullHeight,
      fullHeight = _ref$fullHeight === void 0 ? false : _ref$fullHeight,
      _ref$wrapTitle = _ref.wrapTitle,
      wrapTitle = _ref$wrapTitle === void 0 ? false : _ref$wrapTitle;
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    noSidePadding: noSidePadding,
    style: {
      backgroundColor: backgroundColor || null,
      minHeight: '100%',
      paddingBottom: 30,
      height: fullHeight ? '100%' : undefined
    }
  }, children);
};

var _default = TitledContainer;
exports["default"] = _default;